import globals from "@/utils/globals";
import { ISubscriber } from "@studyportals/event-aggregation-service-interface";
import { CurrencyConversionServiceReadyEvent } from "@studyportals/portal-localized-content";

export default class CurrencyConversionPlugin implements ISubscriber<CurrencyConversionServiceReadyEvent> {
	public initiate(): void {
		globals.eventAggregationService.subscribeTo(CurrencyConversionServiceReadyEvent.EventType, this, true);
	}

	public notify(event: CurrencyConversionServiceReadyEvent): void {
		globals.currencyConversionService = event.currencyConversionService;
	}
}